import React, { ReactElement, useContext } from 'react'
import { LanguageCME } from '../../../i18n'
import CLanguageHandler from '../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../Common/Contexts'
import { openModalHelpPortal } from '../Common/Utils/HelpPortal'
import { RoundedButton } from '../../ReactRouting/Components/Atoms/RoundedButton/RoundedButton'

/**
 * Component properties type.
 */
type Props = {
    servletPath: string
    isSubmitDisabled: boolean
    closeModal: () => void
    isViewOnly?: boolean
}

/**
 * CME Modal action items.
 * @param servletPath The path of the servlet.
 * @param isSubmitDisabled Whether the submit button is disabled.
 * @param closeModal Close modal handler.
 */
const FooterActions: React.FC<Props> = ({
    servletPath,
    isSubmitDisabled,
    closeModal,
    isViewOnly
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(LanguageCME.NAME)

    const handleHelpClick = (): void => openModalHelpPortal(servletPath)

    return (
        <>
            {!isViewOnly ? (
                <div className='tabs-footer'>
                    <RoundedButton type='button' onClick={handleHelpClick} shrink>
                        {language.get(LanguageCME.LanguageCME_ButtonHelpLabel)}
                    </RoundedButton>
                    <RoundedButton disabled={isSubmitDisabled} type='submit' shrink>
                        {language.get(LanguageCME.LanguageCME_ButtonSubmitLabel)}
                    </RoundedButton>
                    <RoundedButton
                        onClick={(): void => {
                            closeModal()
                        }}
                        type='button'
                        isOutlined={true}
                        shrink
                    >
                        {language.get(LanguageCME.LanguageCME_ButtonCancelLabel)}
                    </RoundedButton>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default FooterActions
